import React, { useState, useEffect, useRef } from 'react';
import './Styles.css'; // Import your CSS file
import { useNavigate } from "react-router-dom";


const Navbar = () => {
    const nav = useNavigate()
  const [menuActive, setMenuActive] = useState(false);
  const menuRef = useRef(null);
  const [alertStatus, setalertStatus] = useState('Alert ME')
  const [Agency, setAgency] = useState(false)

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  const handleOutsideClick = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      // Click occurred outside the menu, so close the toggle
      setMenuActive(false);
    }
  };

  useEffect(() => {
    const storedEmail = localStorage.getItem('submittedEmail');
    const agency = localStorage.getItem('Agencyid');
    if (storedEmail) {
      setalertStatus("Alert ON 🔔")
    }


    if(agency){

setAgency(true)



    }






  }, []);


  useEffect(() => {
    window.addEventListener('click', handleOutsideClick);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <header>
      <div className="container">
        <div className="logo">DISASTERALERT</div>
        <nav>
          <div
            className={`menu-toggle ${menuActive ? 'active' : ''}`}
            onClick={toggleMenu}
            id="menu-toggle"
            ref={menuRef} // Add a ref to the menu element
          >
            {/* Add the cross symbol when the menu is active */}
            {menuActive ? (
              <div className="cross">
                <div className="bar bar1"></div>
                <div className="bar bar2"></div>
              </div>
            ) : (
              // Add the hamburger icon when the menu is not active
              <div className="hamburger">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
            )}
          </div>


          {Agency?<>
          
            <ul className={`menu ${menuActive ? 'active' : ''}`} id="menu">
          
      
          <li  onClick={()=>nav('/')}>Alerts!</li>
          <li  onClick={()=>nav('/earthq')}>Earthquake!</li>
          <li onClick={()=>nav('/search')}>Location/Address</li>
          <li  onClick={()=>nav('/statewisealert')}>State</li>

          <li  onClick={()=>nav('/reportdisaster')}>Report Disaster</li>
          <li  onClick={()=>nav('/yourreporting')}>Your Reporting</li>
          <li  onClick={()=>nav('/agencyachivements')}>Your Achivements</li>


        </ul>
          
          
          
          
          
          </>:<>
          
          
          <ul className={`menu ${menuActive ? 'active' : ''}`} id="menu">
      
          <li  onClick={()=>nav('/')}>Alerts!</li>
          <li  onClick={()=>nav('/earthq')}>Earthquake!</li>
          <li onClick={()=>nav('/search')}>Location/Address</li>
          <li  onClick={()=>nav('/statewisealert')}>State</li>
          <li onClick={()=>nav('/alertme')}>{alertStatus}</li>
          <li  onClick={()=>nav('/viewreporteddisaster')}>View Reported Disasters</li>
          <li  onClick={()=>nav('/viewagency')}>View Agencies</li>


        </ul>
          
          
          
          
          
          
          
          
          </>}






    
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
